<template>
  <div>
    <div class="faq-form mb-3">
      <feather class="search-icon" type="search"></feather>
      <b-form-input
        type="text"
        placeholder="Search.."
        v-model="search"
      ></b-form-input>
    </div>
    <!-- <div>
      <Transition-group
        tag="div"
        class="default-according style-1"
        style="list-style-type: none"
        @before-enter="onBeforeEnter"
        @enter="onEnter"
        @leave="onLeave"
      > -->
    <!-- {{ folder }} -->
    <div style="height: 64vh; overflow-y: scroll">
      <b-list-group
        no-body
        v-for="(object, i) in newList"
        tag="a"
        :key="i"
        :data-index="object.name + i"
      >
        <!-- style="height: 2.8rem; cursor: pointer" -->
        <b-list-group-item
          v-b-toggle="`primary_icon_open_close_${i}`"
          class="txt-dark d-flex justify-content-between"
        >
          <span>
            <i class="icon-folder"></i>
            <small>
              {{ object.name }}
            </small>
          </span>
          <small class="when-opened pt-1">
            <i class="icon-angle-down m-0"></i>
          </small>
          <!-- <small class="when-closed pt-1">
          <i class="icon-angle-up m-0"></i>
        </small> -->
        </b-list-group-item>
        <b-collapse
          :id="`primary_icon_open_close_${i}`"
          :accordion="`accordion-${i}`"
          role="tabpanel"
        >
          <b-card-body class="p-0">
            <b-list-group flush style="cursor: pointer">
              <b-list-group-item
                v-for="(item, j) in object.folder"
                :key="i + j"
                style="cursor: pointer"
                @click="toggleItem(item)"
                :class="tab == item ? 'active text-primary' : ''"
              >
                {{ item.name }}</b-list-group-item
              >
            </b-list-group>
          </b-card-body>
        </b-collapse>
      </b-list-group>
    </div>
    <!-- </Transition-group>
    </div> -->
  </div>
</template>

<script>
  import gsap from 'gsap';
  import { requestService } from '../../_services';
  export default {
    data() {
      return {
        template: [],
        search: '',
        tab: null,
      };
    },

    computed: {
      newList() {
        const list = JSON.parse(JSON.stringify(this.template));
        let filtered = list.filter((x) => {
          if (x.folder != null) {
            if (x.name.toLowerCase().includes(this.search)){ //check folder name
              return true;
            } else {
              return x.folder.some((g) => { //check name
                return g.name.toLowerCase().includes(this.search);
              });
            }
          }
        });
        filtered.map((item) => {
          if (item.name.toLowerCase().includes(this.search)){ //check folder name
            return true;
          } else {
            item.folder = item.folder.filter((x) =>{ //check name
              return x.name.toLowerCase().includes(this.search);
            });
          }
        });

        return filtered;
      },
    },
    async mounted() {
      await this.getTemplate();
    },
    methods: {
      toggleItem(item) {
        if (this.tab == null) {
          this.tab = item;
        } else if (this.tab != null) {
          this.tab = item;
        }
        this.$root.$emit('setTemplate', this.tab);
      },
      onBeforeEnter(element) {
        element.style.height = 0;
        element.style.opacity = 0;
      },
      onEnter(element, done) {
        gsap.to(element, {
          height: '2.8rem',
          opacity: 1,
          onComplete: done,
        });
      },
      onLeave(element, done) {
        gsap.to(element, {
          opacity: 0,
          height: 0,
          onComplete: done,
        });
      },
      async getTemplate() {
        let url = '/api/mail/folder/template/filter?search=';

        const resTemplate = await requestService.GetFetch('ccp', url);
        const template = await resTemplate.json();

        this.template = template.data;
      },
    },
  };
</script>

<style scoped>
  .list-move {
    transition: all 1s;
  }
  .active {
    background-color: #e4edff !important;
    border-color: #e4edff !important;
  }

  .collapsed > .when-opened {
    transform: rotate(-180deg);
    transition: all 0.3s ease-in-out;
  }
  :not(.collapsed) > .when-opened {
    transition: all 0.3s;
  }
</style>
